
import React, { Suspense, useState, useEffect } from 'react';
import {
    BrowserRouter as Router,
    Link
} from 'react-router-dom';
import axios from "axios";
import callGetApi from "../../requests/GetRequests";
import * as Constants from '../../requests/URLConstants';
import TableComponent from "common/TableComponent";
import ErrorPanel from "common/ErrorPanel";
import GroupButton from "components/GroupButton/ButtonContainer";
import { DataTableSkeleton } from 'carbon-components-react';
import "global.scss";
import i18n from "../../i18n";
import * as MockData from './Mock.json' 
import qs from 'query-string';
import { useLocation } from 'react-router';
import * as workspaces from '../../config/WorkspaceConstants'

require("./TaskDetails.scss");
let base64 = require('base-64');
var config = require('../../config/appConfig');

const basicAuth =
    'Basic ' +
    base64.encode(`${config.Username}:${config.Password}`);



export const TaskDetails = (props) => {
    const [incidentUrl, setIncidentUrl] = useState('');
    const [incident_id, setIncidentId] = useState('');
    const [containerId, setContainerId] = useState('');
    const [taskId, setTaskId] = useState('');

    const TaskName = i18n.t('taskDetails.TaskName');
    const AlertName = i18n.t('taskDetails.AlertName');
    const AssignedGroup = i18n.t('taskDetails.AssignedGroup');
    const Rating = i18n.t('taskDetails.Rating');
    const PartyName = i18n.t('taskDetails.PartyName');
    const AlertTime = i18n.t('taskDetails.AlertTime');
    const Status = i18n.t('taskDetails.Status');
    const location = useLocation();

    const [headers, setheaders] = useState([
        {
            key: 'TaskName',
            header: TaskName
        }, {
            key: 'alertName',
            header: AlertName
        }, {
            key: 'status',
            header: Status
        }, {
            key: 'groupId',
            header: AssignedGroup
        }, {
            key: 'rating',
            header: Rating
        }, {
            key: 'partyName',
            header: PartyName
        }, {
            key: 'alertTime',
            header: AlertTime
        }]);
    const [showModal, setshowModal] = useState(false);
    const [approveModal, setapproveModal] = useState(false);
    const [taskid, settaskid] = useState('');
    const [rows, setrows] = useState([]);
    const [approve, setapprove] = useState([]);
    const [reject, setreject] = useState([]);
    const [taskStatus, setTaskStatus] = useState('');
    const [taskName, settaskName] = useState('');
    const [taskActualOwner, settaskActualOwner] = useState('');
    const [isShow, setisShow] = useState(false);
    const [loader, setLoader] = useState(true)
    const [isActive, setisActive] = useState(true)
    const [approveSuccessModal, setapproveSuccessModal] = useState(false)
    const [allTasks, setallTasks] = useState([]);
    const [selectedIncident, setselectedIncident] = useState('')
    const [error, setError] = useState();

    useEffect(() => {
        getUserTasks();
    }, []);

    function getReject() {
        fetch(config.serverUrl + '/api/JVPM/getReject?' + new URLSearchParams({
            containerId: rows[0].containerId,
            taskId: rows[0].taskId
        }), {
            method: 'GET',
            withCredentials: true,
            credentials: "include",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': basicAuth,
            },
        })
            .then(response => {
                // this.setState({taskStatus:"Rejected"})
                setTaskStatus("Rejected");
                //  this.getUpdatedTaskStatus();
                getUserTasks();
                // setTaskStatus("");

                //console.log("response is " + response.data);  //task-status
            });
    };

    function getApprove() {
        setLoader(true)
        callGetApi(Constants.GETAPPROVE + new URLSearchParams({
            containerId: rows[0].containerId,
            taskId: rows[0].taskId
        }), {
            method: 'GET',
            withCredentials: true,
            credentials: "include",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': basicAuth,
            },
        }).
            then(response => {
                //console.log("response is " + response.data);  //task-status
                // this.setState({taskStatus:"Completed"})
                //  this.getUpdatedTaskStatus();
                setapproveSuccessModal(true)
                getUserTasks();
                // console.log("response is " + response.data["active-user-tasks"]["task-summary"][0]["task-id"]);
            });
    };

    function getCompletedTasks(bool) {
        setisActive(bool)
        getUserTasks(bool)
    }
    function prepareTaskData(resp) {
        let rowsArray = [];
        let taskobject = {};
        let data = resp;
        if (data.length) {
            for (let i = 0; i < data.length; i++) {
                taskobject = {};
                taskobject.id = "taskId" + data[i]["task-id"] + i;
                taskobject.TaskName = data[i]["task-input-data"]["TaskName"]
                taskobject.alertName = data[i]["task-input-data"]["entries"]["alertName"]
                taskobject.status = data[i]["task-status"];
                taskobject.groupId = data[i]["task-input-data"]["GroupId"];
                taskobject.rating = data[i]["task-input-data"]["entries"]["rating"]
                taskobject.partyName = data[i]["task-input-data"]["entries"]["partyName"]
                taskobject.alertTime = new Date(data[i]["task-input-data"]["entries"]["alertTime"]).toISOString();
                taskobject.incident_id = data[i]["task-input-data"]["entries"]["incident_id"];
                taskobject.updated_on = data[i]["task-input-data"]["entries"]["lastUpdateTime"];
                taskobject.lockedEntries = data[i]["task-input-data"]["entries"]["lockedEntries"];
                taskobject.incidentUrl= data[i]["task-input-data"]["entries"]["incident_url"];
                taskobject.taskId = data[i]["task-id"]
                taskobject.containerId = data[i]["task-container-id"]
                rowsArray.push(taskobject);
            }
        }
        return rowsArray;
    }
    function getUserTasks(isActiveFlag) {
        isActiveFlag = typeof isActiveFlag == 'undefined' ? true : isActiveFlag;
        let rowsArray = [];
        let taskData = {};
        
        // fetch(config.serverUrl + '/api/JVPM/getUserTasks' , {
        setLoader(true);
        setError(null);
        callGetApi(Constants.GETUSERTASKS + isActiveFlag, {
            withCredentials: true,
            credentials: "include",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': basicAuth,
            },
        }).then(resp => {
            //console.log("states/ResposefromUsertask-->" + resp);
            // this.setState({ rows: taskData, isShow : true, showModal:true, incident_url:taskData.incident_url, incident_id:taskData.incident_id});
            if(resp.error) {
                setError(resp.error);
            } else {
                taskData = prepareTaskData(resp)
                setallTasks(taskData);
                setisShow(true);
                setshowModal(true);
                setIncidentUrl(taskData.length ? taskData[0].incidentUrl : '');//To Do for different incidents
                setIncidentId(taskData.length ? taskData[0].incident_id : '');
            }
            setLoader(false)
            //   this.setState({ rows: taskData, isShow : true, showModal:true});
        }).catch((error) => {
            //console.log("getusertask error",error)
            setLoader(false);
            setError(error);
        });
    }

    useEffect(() => {
        filterTaskByIncident(allTasks.length ? allTasks[0].incident_id: null);
    }, [allTasks]);

    function filterTaskByIncident(incidentId) {
        setselectedIncident(incidentId)
        if(incidentId) {
            let filteredTask = allTasks.filter(function (e) {
                return e.incident_id === incidentId;
            });
            setrows(filteredTask);
        } else {
            setrows(allTasks);
        }
    }

    function getApproveModal() {
        setapproveModal(true);
    }
    function closeShowApproveSuccess() {
        setapproveSuccessModal(false)
    }
    function loadData() {
        var promise = new Promise((resolve, reject) => {
            setTimeout(() => {
                //console.log('This happens 6th (after 3 seconds).');
                resolve('This is my data.');
            }, 3000);
        });
        //console.log('This happens 4th.');
        return promise;
    }

    function getUpdatedTaskStatus() {
        let rowsArray = [];
        axios.get(config.serverUrl + '/api/JVPM/getUpdatedTaskStatus', {
            withCredentials: true,
            credentials: "include",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': basicAuth,
            },
        })
            .then(response => {
                loadData();
                if (response.data["active-user-tasks"] !== null) {
                    let taskLoop = response.data["active-user-tasks"]["task-summary"];
                    // const incidentId = incident_id;
                    // console.log("sdaasssassa"+incident_id);
                    taskLoop.forEach(function (element) {
                        let taskobject = { incident_id: incident_id };
                        taskobject['TaskName'] = element["task-name"];
                        taskobject['taskId'] = element["task-id"];
                        taskobject['taskStatus'] = element["task-status"];
                        rowsArray.push(taskobject);
                    });
                }
                else {
                    let taskobject = {};
                    taskobject['TaskName'] = taskName;
                    taskobject['taskActualOwner'] = taskActualOwner;
                    taskobject['taskStatus'] = taskStatus;
                    taskobject.incident_id = incident_id
                    rowsArray.push(taskobject);
                }
                setrows(rowsArray);
                //console.log("states/claimed-->" + response);
                // this.setState({ users: response.data["active-user-tasks"]["task-summary"][0]["task-actual-owner"] });
            }).catch(() => {
                setLoader(false);
            });
    }
    function getClaim() {
        setLoader(true)
        let rowsArray = [];
        callGetApi(Constants.GETCLAIM + new URLSearchParams({
            containerId: rows[0].containerId,
            taskId: rows[0].taskId
        }), {
            method: 'GET',
            withCredentials: true,
            credentials: "include",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': basicAuth,
            },
        }).then(response => {

            // this.setState({rows: rowsArray});
            //console.log("states/claimed-->" + response);
            //  this.getUpdatedTaskStatus();
            getUserTasks();
            // this.setState({ users: response.data["active-user-tasks"]["task-summary"][0]["task-actual-owner"] });
        }).catch(() => {
            setLoader(false);
        });

    }

    function getReject() {
        callGetApi(Constants.GETREJECT, {
            method: 'GET',
            withCredentials: true,
            credentials: "include",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': basicAuth,
            },
        })
            .then(response => {
                // setTaskStatus("Rejected");
                // getUpdatedTaskStatus();
                getUserTasks();
                //console.log("response is " + response.data);  //task-status
                // console.log("response is " + response.data["active-user-tasks"]["task-summary"][0]["task-id"]);
            }).catch(() => {
                setLoader(false);
            });
    };
    let user = JSON.parse(localStorage.getItem('user'));
    const AssistedRemediation = i18n.t('manageAutomation.AssistedRemediation');
    const loading = i18n.t('manageAutomation.loading');
    const noActiveTask = i18n.t('manageAutomation.noActiveTask');
    const please = i18n.t('manageAutomation.please');
    const SignUp = i18n.t('manageAutomation.SignUp');
    const Dashboard = i18n.t('taskDetails.Dashboard');
    const MessagingComponent = React.lazy(() => import("../TaskDetails/MessagingCentreComponent.js"));
    let sysId = incidentUrl ? incidentUrl.substr(incidentUrl.indexOf("=") + 1) : "";
    //console.log("sysId is " + sysId);
    let alertType = 'alert';
    // let path = '/IncidentDetails/' + alertType + "/";
    let path = '/IncidentDetails/';

    // path = path + sysId;
    /* Query Parameters */
    const queryParam = qs.parse(location.search);
    const newQueryParam = {
        ...queryParam,
        sysId: sysId,
        alertType: alertType,
        incidentId: isShow && rows[0] ? rows[0].incident_id : '',
        workspace: workspaces.sap_ops,
        client:  isShow && rows[0] ? rows[0].partyName :''
    }
    /* Query Parameters */

    //console.log("path is" + path);
    if (user !== null && user.access_token !== null) {
        return (
            <>
                <div className="App">
                    <div className="task-content margin-top-40px">
                        <Suspense fallback={<div>{loading}</div>}>
                            {isShow &&
                                <section>
                                    {showModal ? <MessagingComponent rows={allTasks} filterTaskByIncident={filterTaskByIncident} isActive={isActive} getCompletedTasks={getCompletedTasks} selectedIncident={selectedIncident} /> : ''}
                                </section>
                            }
                        </Suspense>
                        <div>
                            <div className="message-table">
                                <div className="incident-details">
                                    {rows.length ? <Link className="incident-no" to={{pathname: path, search: qs.stringify(newQueryParam)}}>{isShow ? rows[0].incident_id : ''}</Link> : ''}
                                    <div className="incident-assisted"> | {AssistedRemediation}</div>
                                    {!loader ?
                                        <div className="claim-button">
                                            <GroupButton getApproveModal={getApproveModal} isActive={isActive}
                                                approveSuccessModal={approveSuccessModal} closeShowApproveSuccess={closeShowApproveSuccess}
                                                status = {rows.length ? rows[0]["status"] : ''}
                                                getApprove={(e) => { getApprove(e) }}
                                                getReject={(e) => { getReject(e) }}
                                                getClaim={(e) => getClaim(e)}
                                            />
                                        </div>
                                        :
                                        ''
                                    }
                                </div>

                                <hr className="line-message " />
                                <div className="table-padding-message">
                              
                                    {!loader ?
                                        error ?
                                        <ErrorPanel showCompletePanel={true} error={error}/>
                                        :
                                        rows.length ? <TableComponent rows={rows}
                                        lockedEntries={true} isExpanded={true} headers={headers} />
                                        :
                                        <h5>
                                            {noActiveTask}
                                            <a href={`https://development.aocc-staging-lon02-b3c-7dced0308bf9da27b6e714d1d05f7137-0000.eu-gb.containers.appdomain.cloud`}> {Dashboard} </a>
                                        </h5>
                                        :
                                        <DataTableSkeleton
                                            columnCount={headers.length}
                                            rowCount={3}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    } else {
        return (
            <div>
                <h2>{please}<a href={`https://development.aocc-staging-lon02-b3c-7dced0308bf9da27b6e714d1d05f7137-0000.eu-gb.containers.appdomain.cloud/login`}> {SignUp} </a> </h2>
            </div>
        );
    }

}
